import {
  DocumentTextIcon,
  HomeIcon,
  SpeakerWaveIcon,
  UserIcon,
  WrenchIcon,
} from '@heroicons/react/24/solid';

const DropdownMenuNavigations = [
  {
    label: 'Dashboard',
    link: '/dashboard',
    icon: <HomeIcon className="w-5 h-5 mb-1 text-white" />,
  },
  {
    label: 'Sound Recordings',
    link: '/sound-recordings',
    icon: <SpeakerWaveIcon className="w-5 h-5 mb-1 text-white" />,
  },
  {
    label: 'Recordings in Dispute',
    link: '/musical-opposition',
    icon: <WrenchIcon className="w-5 h-5 mb-1 text-white" />,
  },
  {
    label: 'Sound Recording Logs',
    link: '/sound-recording-logs',
    icon: <DocumentTextIcon className="w-5 h-5 mb-1 text-white" />,
  },
  {
    label: 'Account',
    link: '/profile',
    icon: <UserIcon className="w-5 h-5 mb-1 text-white" />,
  },
];

export default DropdownMenuNavigations;
